export const slideTypes = {
    info: 'Information',
    streams: 'Streams',
    countdown: 'Countdown',
    chat: 'Chat',
    empty: 'Leer'
}
